import Nullstack from 'nullstack';
export default function IconCpu({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-cpu",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("rect", {
    x: "5",
    y: "5",
    width: "14",
    height: "14",
    rx: "1"
  }), "   ", Nullstack.element("path", {
    d: "M9 9h6v6h-6z"
  }), "   ", Nullstack.element("path", {
    d: "M3 10h2"
  }), "   ", Nullstack.element("path", {
    d: "M3 14h2"
  }), "   ", Nullstack.element("path", {
    d: "M10 3v2"
  }), "   ", Nullstack.element("path", {
    d: "M14 3v2"
  }), "   ", Nullstack.element("path", {
    d: "M21 10h-2"
  }), "   ", Nullstack.element("path", {
    d: "M21 14h-2"
  }), "   ", Nullstack.element("path", {
    d: "M14 21v-2"
  }), "   ", Nullstack.element("path", {
    d: "M10 21v-2"
  }), " ");
}